// deviceConfigure.js
// external libs
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import Spinner from '../../util/spinner-shim'
import { useParams, useNavigate } from 'react-router-dom'

import AppDispatcher from '../../dispatchers/AppDispatcher'
import withAppStore from '../../util/withAppStore'

// internal libs
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import ConfigurePage from '../partials/ConfigurePageComponents/ConfigurePage'
import ModemReplacementWarning from '../partials/SettingPageComponents/ModemReplacementComponents/PopUps/MultiReplacementPopUp'

import styles from '../../../css/devicePage.module.css'

const { pageWidth } = styles

function DeviceConfigure (props) {
  const { customerID, deviceID } = useParams()
  const navigate = useNavigate()

  const [state, setState] = React.useState({
    multipleDevices: false,
  })

  const getNewData = React.useCallback(() => {
    AppDispatcher.dispatch({
      action: 'get-device',
      deviceID,
    })
  }, [deviceID])

  const backToCustomerList = React.useCallback(() => {
    const { data: { history: { list = [] } = {} } = {} } = props
    navigate(list.length > 0 ? list : '/home')
  }, [props.data?.history?.list, navigate])

  const toAdvancedSettings = React.useCallback(() => {
    navigate(`/${customerID}/devices/${deviceID}/settings`)
  }, [customerID, deviceID, navigate])

  React.useEffect(() => {
    getNewData()
  }, [getNewData])

  React.useEffect(() => {
    // Poll device data once per minute to reduce refresh frequency on the device page
    const interval = setInterval(getNewData, 60000)
    return () => clearInterval(interval)
  }, [getNewData])

  React.useEffect(() => {
    const {
      lookup,
      lookupReady,
    } = props.data || {}

    if (lookupReady && lookup) {
      const {
        physical: {
          deviceType = '',
        } = {},
        interface_versioned: {
          data: {
            other: {
              page: interfacePage = '',
            } = {},
          } = {},
        } = {},
      } = lookup[deviceID] || {}

      if (deviceType === 'moistureSensor') navigate(`/${customerID}/moistureSensor/${deviceID}`)
      if (deviceType === 'pump') {
        if (interfacePage === 'flow') {
          navigate(`/${customerID}/flow/${deviceID}`)
        } else {
          navigate(`/${customerID}/pump/${deviceID}`)
        }
      }
      if (deviceType === 'flow') navigate(`/${customerID}/flow/${deviceID}`)
      if (deviceType === 'valve') {
        if (interfacePage === 'flow') {
          navigate(`/${customerID}/flow/${deviceID}`)
        } else {
          navigate(`/${customerID}/valve/${deviceID}`)
        }
      }
      if (deviceType === 'pressureSwitch') navigate(`/${customerID}/pressureSwitch/${deviceID}`)
    }
  }, [props.data?.lookup, props.data?.lookupReady, customerID, deviceID, navigate])

  const render = () => {
    const {
      auth: {
        logout,
      } = {},
      data,
      pages: {
        DeviceConfigure: title,
      } = {},
      route: {
        path: page,
      } = {},
    } = props

    const {
      lookup,
      lookupReady,
    } = data || {}

    if (!data || !lookup) {
      return (
        <div className='loading'>
          <Spinner name='double-bounce' />
        </div>
      )
    }

    const {
      multipleDevices,
    } = state

    const device = lookup[deviceID]

    let subject

    if (lookupReady && device) {
      subject = (
        <div className={pageWidth}>
          <ConfigurePage device={device} data={data} />
        </div>
      )
    } else {
      subject = (
        <div className='loading'>
          <Spinner name='double-bounce' />
        </div>
      )
    }

    let ModemReplacementPopUp

    if (lookupReady && device) {
      ModemReplacementPopUp = (
        <ModemReplacementWarning
          device={device}
          customerID={customerID}
          groupID={null}
          deviceGroupName={null}
          multipleDevices={multipleDevices}
        />
      )
    }

    const subMenuName = device ? device.physical.deviceNumber : ''

    return (
      <div>
        <Helmet><title>{title}</title></Helmet>
        <NavigationBar
          backFunc={backToCustomerList}
          page={page}
          name={subMenuName}
          logOut={() => logout(navigate)}
          rightControl={{
            icon: 'fa-cog',
            func: toAdvancedSettings,
          }}
        />
        {ModemReplacementPopUp}
        {subject}
        <Footer />
      </div>
    )
  }

  return render()
}

DeviceConfigure.propTypes = {
  auth: PropTypes.object,
  data: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
}

export default withAppStore(DeviceConfigure)
